import { INewLog } from 'modules/accommodations/features/reservations/models';
import API from 'services/api';

interface IProps {
  reservationId: string;
  logId?: string;
  payload: INewLog | FormData | any;
}

export const createCalculationLog = ({ reservationId, logId, payload }: IProps) => {
  const headers = {
    'Content-Type': 'multipart/form-data;',
  };

  if (!!logId) {
    return API.put(`api/accommodation/calculations/logs/${logId}`, payload, {
      headers: headers,
    });
  } else {
    return API.post(`api/accommodation/calculations/${reservationId}/logs`, payload, {
      headers: headers,
    });
  }
};
